import i18n from '@/i18n'

import { ROOM_TYPES, type RoomType } from '../constants/room-types'

export const getRoomTypeOptions = (): { label: string; value: RoomType }[] =>
  ROOM_TYPES.map(roomType => ({
    value: roomType,
    label: i18n.t(`room-type.${roomType}`, { ns: 'rooms' })
  }))
